"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ProskommaRender = require('./ProskommaRender');

var camelCase2snakeCase = s => {
  var ret = [];

  for (var c of s.split("")) {
    if (c.toUpperCase() === c && c.toLowerCase() !== c) {
      ret.push("_".concat(c.toLowerCase()));
    } else {
      ret.push(c);
    }
  }

  return ret.join("");
};

class ProskommaRenderFromProskomma extends ProskommaRender {
  constructor(spec) {
    super(spec);

    if (!spec.proskomma) {
      throw new Error("No Proskomma");
    }

    this.pk = spec.proskomma;
    this._tokens = [];
    this._container = null;
  }

  renderDocument1(_ref) {
    var {
      docId,
      config,
      context,
      workspace,
      output
    } = _ref;
    var environment = {
      config,
      context,
      workspace,
      output
    };
    context.renderer = this;
    var documentResult = this.pk.gqlQuerySync("{document(id: \"".concat(docId, "\") {docSetId mainSequence { id } nSequences sequences {id} headers { key value } } }"));
    var docSetId = documentResult.data.document.docSetId;
    var mainId = documentResult.data.document.mainSequence.id;
    var nSequences = documentResult.data.document.nSequences;
    var sequenceIds = documentResult.data.document.sequences.map(s => s.id);
    var headers = {};

    for (var header of documentResult.data.document.headers) {
      headers[header.key] = header.value;
    }

    var docSetResult = this.pk.gqlQuerySync("{docSet(id: \"".concat(docSetId, "\") {selectors {key value}}}"));
    var selectors = {};

    for (var selector of docSetResult.data.docSet.selectors) {
      selectors[selector.key] = selector.value;
    }

    context.document = {
      id: docId,
      schema: {
        "structure": "flat",
        "structure_version": "0.2.1",
        "constraints": [{
          "name": "perf",
          "version": "0.2.1"
        }]
      },
      metadata: {
        translation: {
          id: docSetId,
          selectors,
          properties: {},
          tags: []
        },
        document: _objectSpread(_objectSpread({}, headers), {}, {
          properties: {},
          tags: []
        })
      },
      mainSequenceId: mainId,
      nSequences
    };
    context.sequences = [];
    this.renderEvent('startDocument', environment);

    for (var sequenceId of sequenceIds) {
      this.renderSequenceId(environment, sequenceId);
    }

    this.renderEvent('endDocument', environment);
  }

  sequenceContext(sequence, sequenceId) {
    return {
      id: sequenceId,
      type: camelCase2snakeCase(sequence.type),
      nBlocks: sequence.nBlocks,
      milestones: new Set([])
    };
  }

  renderSequenceId(environment, sequenceId) {
    var context = environment.context;
    var documentResult = this.pk.gqlQuerySync("{document(id: \"".concat(context.document.id, "\") {sequence(id:\"").concat(sequenceId, "\") {id type nBlocks } } }"));
    var sequence = documentResult.data.document.sequence;

    if (!sequence) {
      throw new Error("Sequence '".concat(sequenceId, "' not found in renderSequenceId()"));
    }

    context.sequences.unshift(this.sequenceContext(sequence, sequenceId));
    this.renderEvent('startSequence', environment);
    var outputBlockN = 0;

    for (var inputBlockN = 0; inputBlockN < sequence.nBlocks; inputBlockN++) {
      var blocksResult = this.pk.gqlQuerySync("{\n               document(id: \"".concat(context.document.id, "\") {\n                 sequence(id:\"").concat(sequenceId, "\") {\n                   blocks(positions:").concat(inputBlockN, ") {\n                     bg {subType payload}\n                     bs {payload}\n                     items {type subType payload}\n                   }\n                 }\n               }\n             }"));
      var blockResult = blocksResult.data.document.sequence.blocks[0];

      for (var blockGraft of blockResult.bg) {
        context.sequences[0].block = {
          type: "graft",
          subType: camelCase2snakeCase(blockGraft.subType),
          blockN: outputBlockN
        };
        context.sequences[0].block.target = blockGraft.payload;
        context.sequences[0].block.isNew = false;
        this.renderEvent('blockGraft', environment);
        outputBlockN++;
      }

      context.sequences[0].block = {
        type: "paragraph",
        subType: "usfm:".concat(blockResult.bs.payload.split('/')[1]),
        blockN: outputBlockN,
        wrappers: []
      };
      this.renderEvent('startParagraph', environment);
      this._tokens = [];
      this.renderContent(blockResult.items, environment);
      this._tokens = [];
      this.renderEvent('endParagraph', environment);
      delete context.sequences[0].block;
      outputBlockN++;
    }

    this.renderEvent('endSequence', environment);
    context.sequences.shift();
  }

  renderContent(items, environment) {
    for (var item of items) {
      this.renderItem(item, environment);
    }

    this.maybeRenderText(environment);
  }

  renderItem(item, environment) {
    if (item.type === 'scope' && item.payload.startsWith('attribute')) {
      if (item.subType === "start") {
        if (!this._container) {
          throw new Error("Start attribute when no container set");
        }

        var scopeBits = item.payload.split('/');

        if (scopeBits[3] in this._container.atts) {
          this._container.atts[scopeBits[3]].push(scopeBits[5]);
        } else {
          this._container.atts[scopeBits[3]] = [scopeBits[5]];
        }
      } else {
        var _scopeBits = item.payload.split('/');

        if (!this._container) {
          this._container = {
            direction: "end",
            type: _scopeBits[1] === 'milestone' ? "end_milestone" : "wrapper",
            subType: "usfm:".concat(camelCase2snakeCase(_scopeBits[2])),
            atts: {}
          };
        }

        if (_scopeBits[3] in this._container.atts) {
          this._container.atts[_scopeBits[3]].push(_scopeBits[5]);
        } else {
          this._container.atts[_scopeBits[3]] = [_scopeBits[5]];
        }
      }
    } else {
      if (this._container) {
        this.maybeRenderText(environment);
        this.renderContainer(environment);
      }

      if (item.type === 'token') {
        this._tokens.push(item.payload.replace(/\s+/g, " "));
      } else {
        if (item.type === "graft") {
          this.maybeRenderText(environment);
          var graft = {
            type: "graft",
            subType: camelCase2snakeCase(item.subType),
            target: item.payload,
            isNew: false
          };
          environment.context.sequences[0].element = graft;
          this.renderEvent('inlineGraft', environment);
          delete environment.context.sequences[0].element;
        } else {
          // scope
          this.maybeRenderText(environment);

          var _scopeBits2 = item.payload.split('/');

          if (["chapter", "verses"].includes(_scopeBits2[0])) {
            if (item.subType === 'start') {
              var mark = {
                type: "mark",
                subType: camelCase2snakeCase(_scopeBits2[0]),
                atts: {
                  number: _scopeBits2[1]
                }
              };
              environment.context.sequences[0].element = mark;
              this.renderEvent('mark', environment);
              delete environment.context.sequences[0].element;
            }
          } else if (_scopeBits2[0] === 'span') {
            var wrapper = {
              type: "wrapper",
              subType: "usfm:".concat(_scopeBits2[0])
            };
            environment.context.sequences[0].element = wrapper;

            if (item.subType === 'start') {
              environment.context.sequences[0].block.wrappers.unshift(wrapper.subType);
              this.renderEvent('startWrapper', environment);
            } else {
              this.renderEvent('endWrapper', environment);
              environment.context.sequences[0].block.wrappers.shift();
            }

            delete environment.context.sequences[0].element;
          } else if (_scopeBits2[0] === 'spanWithAtts') {
            if (item.subType === 'start') {
              this._container = {
                direction: "start",
                type: "wrapper",
                subType: "usfm:".concat(_scopeBits2[1]),
                atts: {}
              };
            }
          } else if (_scopeBits2[0] === 'milestone' && item.subType === "start") {
            this._container = {
              type: "start_milestone",
              subType: "usfm:".concat(camelCase2snakeCase(_scopeBits2[1])),
              atts: {}
            };
          }
        }
      }
    }
  }

  maybeRenderText(environment) {
    if (this._tokens.length === 0) {
      return;
    }

    var elementContext = {
      type: 'text',
      text: this._tokens.join('')
    };
    environment.context.sequences[0].element = elementContext;
    this._tokens = [];
    this.renderEvent('text', environment);
    delete environment.context.sequences[0].element;
  }

  renderContainer(environment) {
    if (this._container.type === "wrapper") {
      var direction = this._container.direction;
      delete this._container.direction;

      if (direction === 'start') {
        environment.context.sequences[0].element = this._container;
        environment.context.sequences[0].block.wrappers.unshift(this._container.subType);
        this.renderEvent('startWrapper', environment);
        delete environment.context.sequences[0].element;
      } else {
        environment.context.sequences[0].element = this._container;
        this.renderEvent('endWrapper', environment);
        environment.context.sequences[0].block.wrappers.shift();
        delete environment.context.sequences[0].element;
      }
    } else if (this._container.type === "start_milestone") {
      environment.context.sequences[0].element = this._container;
      this.renderEvent('startMilestone', environment);
      delete environment.context.sequences[0].element;
    } else if (this._container.type === "end_milestone") {
      environment.context.sequences[0].element = this._container;
      this.renderEvent('endMilestone', environment);
      delete environment.context.sequences[0].element;
    }

    this._container = null;
  }

}

module.exports = ProskommaRenderFromProskomma;